(() => {
  'use strict';
  if (customElements.get('ud-review-carousel')) return;
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const track = this.querySelector('[data-stories-track]');
      if (!track?.children.length) return;
      track.scrollLeft = 0;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const prev = this.querySelector('[data-stories-prev]');
      const next = this.querySelector('[data-stories-next]');
      const buttons = this.querySelector('[data-stories-buttons]');
      const count = this.querySelector('[data-stories-count]');
      const step = () => track.children[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons.hidden = max <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        const size = step();
        if (!size) return;
        const first = Math.max(0, Math.round(track.scrollLeft / size));
        const visible = Math.max(1, Math.floor((track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0) + 1) / size));
        const last = Math.min(track.children.length, first + visible);
        count.textContent = `${first + 1}${last > first + 1 ? '–' + last : ''} / ${track.children.length}`;
      };
      const move = direction => {
        const size = step();
        track.scrollTo({left: Math.round(track.scrollLeft / size) * size + direction * size, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
      }
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('ud-review-carousel', ReviewCarousel);
})();
